import { YuukyuuKanriService } from "@/service/YuukyuuKanriService"
import { computed, ref } from "vue"

/*
 * 有給休暇取得一覧
 */
export function useInfo() {
  let loading = ref(0)
  let isError = ref(false)
  const service = new YuukyuuKanriService()

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  })

  // 有給休暇管理台帳情報取得
  const getDaichouInfo = async (code: number) => {
    loading.value++
    const res = await service.getKanriDaichouInfo(code)
    loading.value--
    return res
  }

  // 指定した付与日の台帳情報を取得
  const getPastDaichouInfo = async (userId: number, start: string, end: string) => {
    loading.value++;
    const res = await service.getPastDaichouInfo(userId, start, end);
    loading.value--;
    return res;
  }

  return {
    getDaichouInfo,
    isLoading,
    isError,
    getPastDaichouInfo,
  }
}

